<template>
  <div v-if="modal" class="modal-container">
    <div class="modal-overlay" @click="closeModal">
      <div class="modal-box" @click.stop>
        <!-- Render dynamic content -->
        <component
          :is="modal.component"
          v-bind="modal.props"
          @close="closeModal"
          @add-card="addCard"
        >
          <!-- Fallback content if no component is provided -->
          <h2>{{ modal.title }}</h2>
          <p>{{ modal.content }}</p>
        </component>
        <button @click="closeModal">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomModalContent from './CustomModalContent.vue';
import SuccessScreen from './SuccessScreen.vue';
import OfferCardModal from '@/views/login/OfferCardModal.vue';

export default {
  components: {
    CustomModalContent,
    SuccessScreen,
    OfferCardModal
  },
  data() {
    return {
      modal: null // Store a single modal configuration
    };
  },
  methods: {
    // Open the modal with the provided configuration
    showModal(modalConfig) {
      console.log('Modal opened:', modalConfig);

      this.modal = modalConfig;
      console.log('Modal opened:', modalConfig);
    },
    // Close the modal and trigger the onClose callback
    closeModal() {
      if (this.modal && this.modal.onClose) {
        this.modal.onClose();
      }
      this.modal = null;
    },
    addCard(offerCard) {
      if (this.modal && this.modal.onAddCard) {
        this.modal.onAddCard(offerCard);
      }
      
    }
  }
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  pointer-events: none;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: all;
}

.modal-box {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 90%;
  width: 400px;
  text-align: center;
}
</style>
